//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useRef, useCallback, useEffect } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, Grid, useTheme, useMediaQuery } from '@material-ui/core';
// import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
// import SimpleBar from 'simplebar-react';
import CloseIcon from '@material-ui/icons/Close';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { logPageView } from '../../system/firebase';
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
// import { LayoutContext, AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { AFITD_DOMAIN, PATH_HOME, PATH_RESOURCE_CENTER } from '../../system/constants';
import { BASE_URL, PAGE_TITLE_RESOURCE_CENTER } from '../../common/constants';
import { getCopyrightText } from '../../common/textHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import bannerImg from '../../images/ResourceCenter/Article 5 Main Image.jpeg';
import bannerLogo from '../../images/ResourceCenter/article1Logo/afitd_primary_logo-01.svg';
import EquipmentLogo from '../../images/ResourceCenter/article5Logo/Equipment.png';
import RecordingLogo from '../../images/ResourceCenter/article5Logo/Recording.png';
import ContentLogo from '../../images/ResourceCenter/article5Logo/Content.png';
import EditingLogo from '../../images/ResourceCenter/article5Logo/Editing.png';
import FinalTipsLogo from '../../images/ResourceCenter/article5Logo/Final Tips.png';
import { useHistory } from 'react-router-dom';

// import cardImg1 from '../../images/FAQ/Rectangle 202.png';
// import cardImg2 from '../../images/FAQ/Rectangle 2021.png';
// import cardImg3 from '../../images/FAQ/Rectangle 2022.png';
// import shareImg1 from '../../images/FAQ/Vector1.png';
// import shareImg2 from '../../images/FAQ/Vector2 (1).png';
// import shareImg3 from '../../images/FAQ/Vector3 (1).png';
// import shareImg4 from '../../images/FAQ/Ic_copy link.png';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdPageHead from '../../common/elemental/AfitdPageHead';
// import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: {
        // '&::-webkit-scrollbar-track': {
        //     borderRadius: '10px',
        //     background: 'none',
        // },
        // '&::-webkit-scrollbar': {
        //     width: '8px',
        //     backgroundColor: '#F5F5F5',
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     borderRadius: '10px',
        //     backgroundColor: 'rgba(0,0,0,0.2)',
        // },
    },
    topText: { fontWeight: 700, fontSize: '16px', lineHeight: '19px', color: '#111E14', textAlign: 'center' },
    heading: {
        color: '#21898A',
        fontWeight: 700,
        fontSize: '42px',
        lineHeight: '52px',
        textAlign: 'center',
        maxWidth: '700px',
        margin: 'auto',
        [theme.breakpoints.down('sm')]: { fontSize: 26, lineHeight: '34px' },
    },
    bannerImg: { textAlign: 'center', marginTop: '45px', marginBottom: '40px' },
    paragraph: {
        fontSize: '20px',
        fontWeight: 400,
        lineHeight: '36px',
        maxWidth: '730px',
        margin: 'auto',
        [theme.breakpoints.down('sm')]: { fontSize: '18px', lineHeight: '32px' },
    },
    questionTitle: {
        fontSize: '22px',
        fontWeight: 'bold',
        lineHeight: '36px',
        maxWidth: '730px',
        margin: 'auto',
        [theme.breakpoints.down('sm')]: { fontSize: '18px', lineHeight: '32px' },
    },
    secondaryHeader: {
        color: '#21898A',
        fontSize: '26px',
        fontWeight: '700',
        lineHeight: '30px',
        marginTop: '70px',
        maxWidth: '730px',
        // margin: 'auto',
        marginBottom: '24px',
        [theme.breakpoints.down('sm')]: { fontSize: 22, lineHeight: '25px' },
    },
    social: { maxWidth: '730px', margin: 'auto', marginTop: '50px', display: 'flex', alignItems: 'center', marginBottom: '30px' },
    iconContainer: {
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        backgroundColor: 'rgba(252, 130, 31, 0.13)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    socialText: { fontSize: '16px', fontWeight: 700, lineHeight: '19px', paddingLeft: '16px' },
    hr: { backgroundColor: '#F0F2F6', margin: 'auto', marginTop: 50, maxWidth: '840px' },
    //  hr: { backgroundColor: '#F0F2F6', maxWidth: '840px', margin: 'auto', marginBottom: '150px', marginTop: 50 },
    navigations: { display: 'flex', justifyContent: 'space-between', maxWidth: '1100px', margin: 'auto', marginTop: '20px' },
    navigationIconContainer: {
        display: 'flex',
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        border: '1px solid #D5D7DD',
        justifyContent: 'center',
        alignItems: 'center',
        '&:hover': { cursor: 'pointer' },
    },
    navigationText: { padding: '0 16px', fontSize: '20', width: '500', fontWeight: 'bold' },
    navigationButtonContainer: { display: 'flex', alignItems: 'center' },
    card: { width: '352px', borderRadius: '8px', border: '1px solid #D5D7DD', '&:hover': { cursor: 'pointer' } },
    cardContainer: { marginTop: '60px', marginBottom: 60 },
    cardContent: { marginBottom: '27px', marginLeft: '24px', marginRight: '20px', borderBottom: '20px solid #fafafc' },
    cardHeading: { fontSize: '26px', fontWeight: 'bold', lineHeight: '34px' },
    cardParagraph: { fontSize: '15px', fontWeight: 400, lineHeight: '24px' },
    cardSocial: { display: 'flex', alignItems: 'center', marginTop: '20px' },
    cardSocialText: { marginLeft: '9px', fontSize: '14px', lineHeight: '16px', fontWeight: 400 },
    cardSection: { display: 'flex', alignItems: 'flex-start', justifyContent: 'center' },
    dateTime: { marginBottom: 0, marginTop: '24px', fontSize: '14px', lineHeight: '16px', fontWeight: 400 },
    shareImageContainer: { textAlign: 'center', marginBottom: '16px', position: 'relative', '&:hover': { cursor: 'pointer' }, [theme.breakpoints.down('sm')]: { marginRight: 10 } },
    shareContainer: { display: 'flex', flexDirection: 'column', marginLeft: '-75px', [theme.breakpoints.down('sm')]: { flexDirection: 'row', marginLeft: 0, marginTop: 50 } },
    shareContainer2: { display: 'flex', flexDirection: 'column', position: 'absolute', top: 0, right: 25, [theme.breakpoints.only('md')]: { top: 360, right: 10 } },
    paragraphContainer: {
        // height: 500,
        [theme.breakpoints.only('md')]: { paddingRight: 30 },
        position: 'relative',
        // overflowY: 'scroll',
        // '&::-webkit-scrollbar-track': {
        //     borderRadius: '10px',
        //     background: 'none',
        // },
        // '&::-webkit-scrollbar': {
        //     width: '8px',
        //     backgroundColor: '#F5F5F5',
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     borderRadius: '10px',
        //     backgroundColor: 'rgba(0,0,0,0.2)',
        // },
    },
    img: { width: '100%' },
    imgLogo: { display: 'flex', maxWidth: 275, zIndex: 1, marginTop: '-47px' },
    tableContainer: { border: '1px solid black', width: '100%', borderCollapse: 'collapse' },
    tableRow: { border: '1px solid black', padding: '5px 10px 10px 10px' },
    tableRowName: { border: '1px solid black', padding: '5px 10px 10px 10px', color: '#21898A', width: 170, fontWeight: 'bold' },
    skillTitle: { color: '#21898A', textDecoration: 'underline', fontWeight: 'bold' },
    skillContainer: { display: 'flex', justifyContent: 'space-around' },
    leftLogo: { width: 90, height: 90 },
    logoHeaderContainer: {
        display: 'flex',
        marginLeft: '121px',
        marginTop: '10px',
        marginBottom: '10px',
        alignItems: 'flex-end',
        [theme.breakpoints.down('md')]: { maxWidth: 730, margin: '0 auto' },
        [theme.breakpoints.down('sm')]: { marginLeft: 0 },
    },
    closeIconContainer: { display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' },
    closeIcon: { color: '#A4A6A5' },
    backToTopContainer: { display: 'flex', justifyContent: 'flex-end', maxWidth: '905px' },
    backToTopText: {
        textDecoration: 'underline',
        color: '#1DA98E',
        fontStyle: 'italic',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: 18,
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
        },
    },
    flexSpaceBetween: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
    copyRightText: {
        marginLeft: theme.spacing(20),
        fontSize: '18px',
        fontWeight: 'bold',
        [theme.breakpoints.down('sm')]: {
            marginLeft: '0px',
            fontSize: '14px',
            maxWidth: '220px',
        },
    },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, handleCloseIcon } = params;

    const defns = {
        icon: { fontSize: '30px', color: '#FC821F', opacity: 1 },
        navIconLeft: { marginLeft: '10px' },
        navIconRight: { marginLeft: '3px' },
        cardContainer: { container: true, spacing: 5 },
        cardSection: { item: true, lg: 4, md: 6, sm: 12, xs: 12 },
        cardIcon: { color: 'rgba(17, 30, 20, 0.4)' },
        pageContent: { container: true },
        paragraphContainer: { item: true, lg: 12, md: 12, sm: 12, xs: 12 },
        shareContainer: { item: true, lg: 0, md: 0, sm: 12, xs: 12 },
        closeIcon: { onClick: handleCloseIcon },
        homeLink: { target: '_blank', href: '/' },
        resourceCenterText: { target: '_blank', href: '/resource-center' },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const ArticleFive = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    const theme = useTheme();
    // const matchesMd = useMediaQuery(theme.breakpoints.down('md'));
    const matchesSm = useMediaQuery(theme.breakpoints.down('sm'));
    const history = useHistory();
    const myRef = useRef(null);
    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    const pageTitle = `ACTION! Making Your AFITD Profile Video | ${PAGE_TITLE_RESOURCE_CENTER}`;
    const pageTitleSeo = 'ACTION! Making Your AFITD Profile Video';

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        logPageView(pageTitle);
    }, [pageTitle]);

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleClickLogo = useCallback(() => {
        history.push(`${BASE_URL}${PATH_HOME}`);
    }, [history]);
    const handleNextButton = () => {
        history.push('/resource-center/1');
    };
    const handlePreviousButton = () => {
        history.push('/resource-center/4');
    };
    const handleCloseIcon = () => {
        history.push('/resource-center');
    };
    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, handleCloseIcon, handleClickLogo });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <AfitdPageHead
                title={pageTitleSeo}
                description="A Foot in the Door provides members with the opportunity to create a powerful 60-second profile video. You can find video and profile examples on the home page."
                keywords="60-second profile video, 60-second video, how to make a 60-second video, 60-second video ideas, 60-second videos"
                canonicalUrl={`https://${AFITD_DOMAIN}${PATH_RESOURCE_CENTER}/5`}
            />
            <div ref={myRef} />
            <p {...defns.topText}>8 min read</p>
            <div {...defns.closeIconContainer}>
                <CloseIcon {...defns.closeIcon} />
            </div>
            <h1 {...defns.heading}>
                ACTION!
                <br />
                Making Your AFITD Profile Video
            </h1>
            <div {...defns.navigations}>
                <div {...defns.navigationButtonContainer} onClick={handlePreviousButton}>
                    <div {...defns.navigationIconContainer}>
                        <ArrowBackIosIcon style={{ ...defns.navIconLeft }} />
                    </div>
                    <span {...defns.navigationText}>Previous</span>
                </div>
                <div {...defns.navigationButtonContainer} onClick={handleNextButton}>
                    <span {...defns.navigationText}>Next</span>
                    <div {...defns.navigationIconContainer}>
                        <ArrowForwardIosIcon style={{ ...defns.navIconRight }} />
                    </div>
                </div>
            </div>

            <div {...defns.bannerImg}>
                <img {...defns.img} src={bannerImg} alt="" />
                <img {...defns.imgLogo} src={bannerLogo} alt="" />
            </div>

            <Grid {...defns.pageContent}>
                {matchesSm ? (
                    <>
                        <Grid {...defns.paragraphContainer}>
                            <div style={{ height: '100%' }} autoHide={false}>
                                <p {...defns.paragraph}>
                                    One of the most bangin’ features <strong>A Foot in the Door</strong> offers our members is the opportunity to create a profile video. This
                                    element of the platform is a game changer because it provides job seekers with something, that at present, you won’t find anywhere else: a
                                    chance to make a “face-to-face,” impression BEFORE an interview is even scheduled.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    The traditional online job search puts your profile in a sea of other profiles, making it the equivalent of your resume’ sitting on a desk pile
                                    of other resume’s like in the olden days. With this modern approach, <strong>A Foot in the Door</strong> has granted you 60 glorious seconds to
                                    introduce yourself and truly set yourself apart from other applicants.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    Videos can make powerful statements, even in just 60 seconds. TikTok reigns supreme as the app of choice for short, but intentional, videos.
                                    They are so popular that you can usually find shared TikToks on every other social media platform. Being a “You-Tuber,” or “influencer,” is an
                                    actual job title now. Videos are where it’s at, and this is your chance to make a 60 second video that could literally change your life.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    Not everyone has experience making videos, and if that’s you, that’s 100% okay. This post is here to give you a few tips on creating a fantastic
                                    video that will have employers swiping right, er...clicking the schedule interview button in your profile, in no time!
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={EquipmentLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Equipment</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    It’s probably safe to say that not all of us have DSLR cameras and ring lights laying around just in case we need to make a video one day.
                                    That’s cool. No one here is expecting your video to win an Oscar for best production. There are several different options for filming (list
                                    below) and all of them will work just fine, especially if you’re able to incorporate a few of the upcoming tips (also below).
                                    <ul>
                                        <li>
                                            <strong>Cell Phone or Tablet: </strong>
                                            Most cell phones or tablets these days have near professional production quality. Whichever phone you have, set that bad boy up on a
                                            tripod or lean it against a pile of books or DVD’s (if you know what those are), or even prop it up against a water bottle. Find that
                                            angle that makes you feel the most gorgeous and hit record!
                                        </li>
                                        <li>
                                            <strong>Computer Camera: </strong>
                                            Computer cameras have come a long way in terms of quality and are a perfectly respectable option for recording your video. Set up shop
                                            on at a table and get ready to work that camera.
                                        </li>
                                        <li>
                                            <strong>DSLR/Professional: </strong>
                                            If you have a DSLR camera or any professional type gear, that’s sweet, and you probably don’t need many of these tips. Please continue
                                            reading anyway because you know, the views.
                                        </li>
                                    </ul>
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={RecordingLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Recording</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    While these videos won’t be introduced at the Sundance Film Festival, it’s still a good idea to try your best to make it a quality product. It
                                    is, after all, a representation of you. If you’re unfamiliar with recording, and especially if you are using a mobile device or computer to
                                    record, take these tips into account:
                                    <ul>
                                        <li>
                                            <strong>Atmosphere: </strong>
                                            Set yourself up in an organized, clean, and well-lit space. Avoid overly cluttered backgrounds as we want you to be the center of
                                            attention. If there are a few items on the wall, that’s acceptable, but we don’t need to see your entire collection of bobble-heads
                                            (unless you’re applying for some type of bobble-head related career position, then that could be appropriate).
                                        </li>
                                        <br />
                                        <li>
                                            <strong>Let there Be Light: </strong>
                                            Speaking of lit, lighting is another crucial video element. Natural lighting is always flattering so maybe try setting up shop near a
                                            window, or even outside. Nature has the best backgrounds. Artificial light is also an option (i.e., a ring light if you have one).
                                        </li>
                                        <br />
                                        <li>
                                            <strong>Landscape: </strong>
                                            We recommend shooting videos in Landscape as opposed to Portrait (selfie mode). It’s a more professional vibe.
                                        </li>
                                    </ul>
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={ContentLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Content</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    This is where this process gets interesting. You have a whole 60 seconds to pitch yourself to a future employer, and yet you only have 60
                                    seconds to pitch yourself to a future employer. Perspective, am-I-right? Fear not, we can help you make the most of that minute! <br />
                                    <ul>
                                        <li>
                                            <strong>Plan: </strong>
                                            Take some time to map out your video concept. In the biz, we call this a storyboard. Write a loose draft, or bullet-points, of what you
                                            want to say. Also jot down any ideas for editing during this phase (i.e., if you want to add in sound effects, graphics, b-roll, etc.).
                                        </li>
                                        <li>
                                            <strong>What should You Say?: </strong>
                                            Keep in mind that your profile also includes a written section, your resume’, and even links to your socials if you choose, so your
                                            video doesn’t have to be your life’s story or work history. Use your video to give a high-level overview of your strengths, personality,
                                            and skills. Use the rest of your profile to flesh out those details
                                        </li>
                                    </ul>
                                </p>
                                <p {...defns.paragraph}>
                                    Think of your video like a movie trailer. You want to highlight enough of the juicy details to entice your audience into buying a ticket to
                                    watch the whole film. The juicy highlights are your top strengths (what you bring to the table in a nutshell) and personality. You’ll know if an
                                    employer bought a ticket to the show when they schedule that first interview!
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={EditingLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Editing</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    If you have any experience making videos, then you know that editing is the most time-consuming part of the process. It can be tedious, but it
                                    is usually also fun! If you don’t have video editing experience, no worries, there are plenty of resources to help you make a kick-booty video
                                    without all the frills.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    Also, keep in mind, that not all videos will require a ton of editing. Sometimes less can be more. If you are searching for an opportunity in a
                                    career realm where exceptional editing could show a potential employer your skill level, then you should absolutely take advantage of that with
                                    your minute of “face time.” Otherwise, no need to stress over that element because you can show how skilled and unique you are in other ways
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    If you’re an editing pro you probably already have an editing software of choice. If you’re an editing newb here are a few free resources that
                                    might be beneficial to you: <br />
                                    <ul>
                                        <li>
                                            <strong>iMovie: </strong> If you have an iPhone, you should have iMovie on your phone automatically and if not, you should be able to
                                            download it from the app store for free. Mac and Macbook owners also have iMovie access. It’s a relatively user-friendly option for
                                            beginners and if you get stuck, there are TONS of tutorials on YouTube.
                                        </li>
                                        <br />
                                        <li>
                                            <strong>Microsoft Photo App: </strong>
                                            For PC users out there check out the Microsoft Photo app that’s included with Windows 10. This tool will enable you to complete minor,
                                            but still neat, editing elements like adding music, combining video and photos, or animated 3D effects.
                                        </li>
                                    </ul>
                                    There are many other free or inexpensive video editing resources available online. Whip out the ol’ Google to find more options but remember to
                                    ensure that if you download anything that it comes from a reputable source.
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={FinalTipsLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Final Tips</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    Before we leave you to the creative process, we have just a few more words of wisdom for you to consider: <br />
                                    <ul>
                                        <li>
                                            <strong>Have Fun: </strong>
                                            Yes, this video should be professional, but it should also be representative of who you are. It’s okay, even encouraged, to have a
                                            little fun with it. Use your creativity to support your words when telling the story of who you are.
                                        </li>
                                        <br />
                                        <li>
                                            <strong>Be Engaging: </strong>
                                            This video is a first impression. As such, you’ll want to entice your audience (read: potential employer) to watch the full 60- seconds.
                                            The tone should be conversational so try pretending like you’re actually speaking to another person while you’re recording. If it helps,
                                            you could ask a friend or family member to hang out off camera and act like you’re speaking to them. Alternatively, you could print out
                                            an image of Simon Cowell (or your reality tv judge of choice) and talk to him. If you can impress Simon, you’re basically golden.
                                        </li>
                                        <br />
                                        <li>
                                            <strong>Be Yourself: </strong>
                                            ...because you’re awesome! You’ve got mad skills and much knowledge, so get out there and let the people know!
                                        </li>
                                        <br />
                                    </ul>
                                    You can find video and profile examples on the <a {...defns.homeLink}>A Foot in the Door home page</a>, and if you’re looking for more career
                                    tips, be sure to check out our other blog posts in the <a {...defns.resourceCenterText}>Resource Center.</a>
                                </p>
                            </div>
                        </Grid>
                        {/* <Grid {...defns.shareContainer}>
                            <Tooltip title="Share the article on LinkedIn" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg1} alt="" />
                                </div>
                            </Tooltip>
                            <Tooltip title="Share the article on Twitter" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg2} alt="" />
                                </div>
                            </Tooltip>
                            <Tooltip title="Share the article on Facebook" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg3} alt="" />
                                </div>
                            </Tooltip>
                            <Tooltip title="Copy the article link" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg4} alt="" />
                                </div>
                            </Tooltip>
                        </Grid> */}
                    </>
                ) : (
                    <>
                        <Grid {...defns.paragraphContainer}>
                            <div style={{ height: '100%' }} autoHide={false}>
                                <p {...defns.paragraph}>
                                    One of the most bangin’ features <strong>A Foot in the Door</strong> offers our members is the opportunity to create a profile video. This
                                    element of the platform is a game changer because it provides job seekers with something, that at present, you won’t find anywhere else: a
                                    chance to make a “face-to-face,” impression BEFORE an interview is even scheduled.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    The traditional online job search puts your profile in a sea of other profiles, making it the equivalent of your resume’ sitting on a desk pile
                                    of other resume’s like in the olden days. With this modern approach, <strong>A Foot in the Door</strong> has granted you 60 glorious seconds to
                                    introduce yourself and truly set yourself apart from other applicants.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    Videos can make powerful statements, even in just 60 seconds. TikTok reigns supreme as the app of choice for short, but intentional, videos.
                                    They are so popular that you can usually find shared TikToks on every other social media platform. Being a “You-Tuber,” or “influencer,” is an
                                    actual job title now. Videos are where it’s at, and this is your chance to make a 60 second video that could literally change your life.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    Not everyone has experience making videos, and if that’s you, that’s 100% okay. This post is here to give you a few tips on creating a fantastic
                                    video that will have employers swiping right, er...clicking the schedule interview button in your profile, in no time!
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={EquipmentLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Equipment</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    It’s probably safe to say that not all of us have DSLR cameras and ring lights laying around just in case we need to make a video one day.
                                    That’s cool. No one here is expecting your video to win an Oscar for best production. There are several different options for filming (list
                                    below) and all of them will work just fine, especially if you’re able to incorporate a few of the upcoming tips (also below).
                                    <ul>
                                        <li>
                                            <strong>Cell Phone or Tablet: </strong>
                                            Most cell phones or tablets these days have near professional production quality. Whichever phone you have, set that bad boy up on a
                                            tripod or lean it against a pile of books or DVD’s (if you know what those are), or even prop it up against a water bottle. Find that
                                            angle that makes you feel the most gorgeous and hit record!
                                        </li>
                                        <li>
                                            <strong>Computer Camera: </strong>
                                            Computer cameras have come a long way in terms of quality and are a perfectly respectable option for recording your video. Set up shop
                                            on at a table and get ready to work that camera.
                                        </li>
                                        <li>
                                            <strong>DSLR/Professional: </strong>
                                            If you have a DSLR camera or any professional type gear, that’s sweet, and you probably don’t need many of these tips. Please continue
                                            reading anyway because you know, the views.
                                        </li>
                                    </ul>
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={RecordingLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Recording</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    While these videos won’t be introduced at the Sundance Film Festival, it’s still a good idea to try your best to make it a quality product. It
                                    is, after all, a representation of you. If you’re unfamiliar with recording, and especially if you are using a mobile device or computer to
                                    record, take these tips into account:
                                    <ul>
                                        <li>
                                            <strong>Atmosphere: </strong>
                                            Set yourself up in an organized, clean, and well-lit space. Avoid overly cluttered backgrounds as we want you to be the center of
                                            attention. If there are a few items on the wall, that’s acceptable, but we don’t need to see your entire collection of bobble-heads
                                            (unless you’re applying for some type of bobble-head related career position, then that could be appropriate).
                                        </li>
                                        <br />
                                        <li>
                                            <strong>Let there Be Light: </strong>
                                            Speaking of lit, lighting is another crucial video element. Natural lighting is always flattering so maybe try setting up shop near a
                                            window, or even outside. Nature has the best backgrounds. Artificial light is also an option (i.e., a ring light if you have one).
                                        </li>
                                        <br />
                                        <li>
                                            <strong>Landscape: </strong>
                                            We recommend shooting videos in Landscape as opposed to Portrait (selfie mode). It’s a more professional vibe.
                                        </li>
                                    </ul>
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={ContentLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Content</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    This is where this process gets interesting. You have a whole 60 seconds to pitch yourself to a future employer, and yet you only have 60
                                    seconds to pitch yourself to a future employer. Perspective, am-I-right? Fear not, we can help you make the most of that minute! <br />
                                    <ul>
                                        <li>
                                            <strong>Plan: </strong>
                                            Take some time to map out your video concept. In the biz, we call this a storyboard. Write a loose draft, or bullet-points, of what you
                                            want to say. Also jot down any ideas for editing during this phase (i.e., if you want to add in sound effects, graphics, b-roll, etc.).
                                        </li>
                                        <li>
                                            <strong>What should You Say?: </strong>
                                            Keep in mind that your profile also includes a written section, your resume’, and even links to your socials if you choose, so your
                                            video doesn’t have to be your life’s story or work history. Use your video to give a high-level overview of your strengths, personality,
                                            and skills. Use the rest of your profile to flesh out those details
                                        </li>
                                    </ul>
                                </p>
                                <p {...defns.paragraph}>
                                    Think of your video like a movie trailer. You want to highlight enough of the juicy details to entice your audience into buying a ticket to
                                    watch the whole film. The juicy highlights are your top strengths (what you bring to the table in a nutshell) and personality. You’ll know if an
                                    employer bought a ticket to the show when they schedule that first interview!
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={EditingLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Editing</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    If you have any experience making videos, then you know that editing is the most time-consuming part of the process. It can be tedious, but it
                                    is usually also fun! If you don’t have video editing experience, no worries, there are plenty of resources to help you make a kick-booty video
                                    without all the frills.
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    Also, keep in mind, that not all videos will require a ton of editing. Sometimes less can be more. If you are searching for an opportunity in a
                                    career realm where exceptional editing could show a potential employer your skill level, then you should absolutely take advantage of that with
                                    your minute of “face time.” Otherwise, no need to stress over that element because you can show how skilled and unique you are in other ways
                                </p>
                                <br />
                                <p {...defns.paragraph}>
                                    If you’re an editing pro you probably already have an editing software of choice. If you’re an editing newb here are a few free resources that
                                    might be beneficial to you: <br />
                                    <ul>
                                        <li>
                                            <strong>iMovie: </strong> If you have an iPhone, you should have iMovie on your phone automatically and if not, you should be able to
                                            download it from the app store for free. Mac and Macbook owners also have iMovie access. It’s a relatively user-friendly option for
                                            beginners and if you get stuck, there are TONS of tutorials on YouTube.
                                        </li>
                                        <br />
                                        <li>
                                            <strong>Microsoft Photo App: </strong>
                                            For PC users out there check out the Microsoft Photo app that’s included with Windows 10. This tool will enable you to complete minor,
                                            but still neat, editing elements like adding music, combining video and photos, or animated 3D effects.
                                        </li>
                                    </ul>
                                    There are many other free or inexpensive video editing resources available online. Whip out the ol’ Google to find more options but remember to
                                    ensure that if you download anything that it comes from a reputable source.
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={FinalTipsLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Final Tips</h2>
                                </div>
                                <p {...defns.paragraph}>
                                    Before we leave you to the creative process, we have just a few more words of wisdom for you to consider: <br />
                                    <ul>
                                        <li>
                                            <strong>Have Fun: </strong>
                                            Yes, this video should be professional, but it should also be representative of who you are. It’s okay, even encouraged, to have a
                                            little fun with it. Use your creativity to support your words when telling the story of who you are.
                                        </li>
                                        <br />
                                        <li>
                                            <strong>Be Engaging: </strong>
                                            This video is a first impression. As such, you’ll want to entice your audience (read: potential employer) to watch the full 60- seconds.
                                            The tone should be conversational so try pretending like you’re actually speaking to another person while you’re recording. If it helps,
                                            you could ask a friend or family member to hang out off camera and act like you’re speaking to them. Alternatively, you could print out
                                            an image of Simon Cowell (or your reality tv judge of choice) and talk to him. If you can impress Simon, you’re basically golden.
                                        </li>
                                        <br />
                                        <li>
                                            <strong>Be Yourself: </strong>
                                            ...because you’re awesome! You’ve got mad skills and much knowledge, so get out there and let the people know!
                                        </li>
                                        <br />
                                    </ul>
                                    You can find video and profile examples on the <a {...defns.homeLink}>A Foot in the Door home page</a>, and if you’re looking for more career
                                    tips, be sure to check out our other blog posts in the <a {...defns.resourceCenterText}>Resource Center.</a>
                                </p>
                                {/* <div {...defns.shareContainer2}>
                                <Tooltip title="Share the article on LinkedIn" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg1} alt="" />
                                    </div>
                                </Tooltip>
                                <Tooltip title="Share the article on Twitter" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg2} alt="" />
                                    </div>
                                </Tooltip>
                                <Tooltip title="Share the article on Facebook" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg3} alt="" />
                                    </div>
                                </Tooltip>
                                <Tooltip title="Copy the article link" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg4} alt="" />
                                    </div>
                                </Tooltip>
                            </div> */}
                            </div>
                        </Grid>
                    </>
                )}
            </Grid>

            <hr {...defns.hr} />
            <div {...defns.backToTopContainer}>
                <div {...defns.flexSpaceBetween}>
                    <div {...defns.copyRightText}>{getCopyrightText()}</div>
                    <p
                        {...defns.backToTopText}
                        onClick={() => {
                            setTimeout(() => {
                                myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }, 100);
                        }}
                    >
                        Back to the top
                    </p>
                </div>
            </div>

            {/* <h2 {...defns.heading}>Related Content</h2>
            <Grid {...defns.cardContainer}>
                <Grid {...defns.cardSection}>
                    <div {...defns.card}>
                        <div {...defns.imageContainer}>
                            <img {...defns.img} src={cardImg1} alt="" />
                        </div>
                        <div {...defns.cardContent}>
                            <p {...defns.dateTime}>2 min read</p>
                            <h3 {...defns.cardHeading}>Remote Workstations for the Discerning Artists</h3>
                            <p {...defns.cardParagraph}>
                                Netflix is poised to become the world’s most prolific producer of visual effects and original animated content. To meet that demand, we need to
                                attract the world’s best artistic talent.{' '}
                            </p>
                        </div>
                    </div>
                </Grid>
                <Grid {...defns.cardSection}>
                    <div {...defns.card}>
                        <div {...defns.imageContainer}>
                            <img {...defns.img} src={cardImg2} alt="" />
                        </div>
                        <div {...defns.cardContent}>
                            <p {...defns.dateTime}>2 min read</p>
                            <h3 {...defns.cardHeading}>Working Remotely: A Complete Guide to Turn You Into a Pro</h3>
                            <p {...defns.cardParagraph}>
                                Working remotely is more difficult in practice than in theory. Turn to this guide with actionable advice from veteran remote workers on how to
                                handle challenges that are
                            </p>
                        </div>
                    </div>
                </Grid>
                {matchesMd ? (
                    <></>
                ) : (
                    <Grid {...defns.cardSection}>
                        <div {...defns.card}>
                            <div {...defns.imageContainer}>
                                <img {...defns.img} src={cardImg3} alt="" />
                            </div>
                            <div {...defns.cardContent}>
                                <p {...defns.dateTime}>2 min read</p>
                                <h3 {...defns.cardHeading}>Brent Potts Joins Airbnb as Vice President of Community Support</h3>
                                <p {...defns.cardParagraph}>
                                    Today we are excited to announce that Brent Potts has joined Airbnb as Vice President of Community Support. Lorem ipsum dolor sit amet.
                                </p>
                            </div>
                        </div>
                    </Grid>
                )}
            </Grid> */}
        </div>
    );
};

export default ArticleFive;
